import { PayrollHero } from './payroll-hero'
import { HaulerHero } from './hauler-hero'
import { LabHero } from './lab-hero'
import { PrincipalHero } from './principal-hero'
import { SupportHero } from './support-hero'
import { Carousel } from 'react-bootstrap'

export default function HeroSection() {
  return (
    <section id="hero">
      <Carousel>
        <Carousel.Item style={{ backgroundImage: `url(assets/img/slide/payroll/slide-1.jpg)` }}>
          <PayrollHero />
        </Carousel.Item>

        <Carousel.Item style={{ backgroundImage: `url(assets/img/slide/hauler/hauler-bg.jpg)` }}>
          <HaulerHero />
        </Carousel.Item>

        <Carousel.Item style={{ backgroundImage: `url(assets/img/slide/lab/bg-cow.jpg)` }}>
          <LabHero />
        </Carousel.Item>
        <Carousel.Item style={{ backgroundImage: `url(assets/img/slide/principal/principal-dahsboard.jpg)` }}>
          <PrincipalHero />
        </Carousel.Item>
        <Carousel.Item style={{ backgroundImage: `url(assets/img/slide/support/help-bg.jpg)` }}>
          <SupportHero />
        </Carousel.Item>
      </Carousel>
    </section>
  )
}
